

const useLocalStorage = () => {
    function setLocalStorage(key: string, value: any) {
        const valueToStore = !!value ? JSON.stringify(value) : "";
        localStorage.setItem(key, valueToStore);
    }

    function getLocalStorage(key: string) {
        const val = localStorage.getItem(key) || "{}";

        if (!val) return null;
        return JSON.parse(val);
    }

    function removeLocalStorage(key: string) {
        localStorage.removeItem(key)
    }

    return { getLocalStorage, setLocalStorage, removeLocalStorage };
    // return [getLocalStorage, setLocalStorage, removeLocalStorage] as const;
}

export default useLocalStorage;


// used local storage keys 

{/*
admin_selected_verifier    
admin_selected_manager
*/}